import { Type } from "@angular/core";
import { HhsgSharedTabInterface } from "../components/common/tab-control/tab.interface";

export class HhsgSharedAdminTab {
    public id: number;
    public isDirty = false;
    public isDisabled = false;
    public isLoading = false;
    public isVisible = true;
    public isSelected = false;
    public labelName: string;
    public tabName: string;

    public constructor(public component: Type<HhsgSharedTabInterface>, private fields?: Partial<HhsgSharedAdminTab>) {
        this.id = fields.id ? fields.id : 0;
        this.isDisabled = fields.isDisabled != null && fields.isDisabled != undefined ? fields.isDisabled : false;
        this.isVisible = fields.isVisible != null && fields.isVisible != undefined ? fields.isVisible : true;
        this.isSelected = fields.isSelected != null && fields.isSelected != undefined ? fields.isSelected : false;
        this.labelName = fields.labelName ? fields.labelName : 'Tab';
        this.tabName = fields.tabName ? fields.tabName : this.id.toString();
    }
}